<template>
  <div>
    <v-toolbar
      light
      color="white"
      class="elevation-2"
    >
      <v-toolbar-title>Użytkownicy</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <v-btn
          slot="activator"
          icon
          @click="addNewUser"
        >
          <v-icon
            color="primary"
          >person_add</v-icon>
        </v-btn>
        <span>Dodaj użytkownika</span>
      </v-tooltip>
    </v-toolbar>
    <UserFetchDialog />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserFetchDialog from './Dialogs/UserFetchDialog.vue';

export default {
  name: 'users-toolbar',
  components: { UserFetchDialog },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    addNewUser() {
      this.setDialogVisbility({ type: 'add' });
    },
  },
};
</script>
